import { jsxs as m, jsx as t, Fragment as u } from "react/jsx-runtime";
import { useState as B, useRef as d, useEffect as f } from "react";
import { useNextgenRouter as M, GenericLink as T, FAIcon as x } from "@nextgen-web-framework/all";
import R from "../ShopByBrands/ShopByBrands.js";
import { s as n, C as _ } from "../../CategoryItemContainer-b5522863.mjs";
import I from "../ImagesAndLinksContainer/ImagesAndLinksContainer.js";
const P = ({ navigations: o, activeRoute: E }) => {
  var k;
  const [r, s] = B(""), h = d(), c = d(), p = d(), i = d(), $ = (k = M()) == null ? void 0 : k.query;
  f(() => {
    r && s("");
  }, [$]), f(() => {
    const e = (a) => {
      var N, v, w, C;
      const l = a.target, L = (v = (N = l == null ? void 0 : l.getElementsByTagName("div")) == null ? void 0 : N[0]) == null ? void 0 : v.id;
      (!((w = c.current) != null && w.contains(l)) && L === "content-full-id" || !((C = i.current) != null && C.contains(l))) && y();
    };
    return document.addEventListener("mousedown", e), document.addEventListener("keydown", (a) => {
      a.key === "Enter" && e(a);
    }), () => {
      document.removeEventListener("mousedown", e), document.removeEventListener("keydown", (a) => {
        a.key === "Enter" && e(a);
      });
    };
  }, [c, i]), f(() => {
    const e = document.getElementsByClassName("amwayMegaMenuModal");
    (e == null ? void 0 : e.length) > 0 && (e[0].scrollHeight <= e[0].getElementsByClassName("full-content")[0].scrollHeight ? document.documentElement.style.setProperty("--modalContentBottom", "0px") : document.documentElement.style.setProperty("--modalContentBottom", "auto"));
  }, [r]);
  const y = () => {
    var e;
    (e = h.current) == null || e.classList.remove(`${n["slide-down"]}`), setTimeout(() => {
      s("");
    }, 200);
  }, g = (e) => {
    if (r !== e) {
      if (r !== "") {
        p.current.children[0].classList.add(`${n["fade-out"]}`), s(e);
        return;
      }
      s(e);
    } else
      y();
  }, b = (e) => e.menuType === "images_and_links" ? /* @__PURE__ */ t(I, { categories: e.categories }) : e.menuType === "links_only" ? /* @__PURE__ */ t(u, { children: e.categories.map((a) => /* @__PURE__ */ t(_, { category: a, title: a.title }, a.title)) }) : e.menuType === "images_only" ? /* @__PURE__ */ t(R, { categories: e.categories }) : /* @__PURE__ */ t(u, {});
  return /* @__PURE__ */ m("div", { ref: i, children: [
    /* @__PURE__ */ t("nav", { "data-testid": "navbar-test-id", "data-pod-name": "commerce", children: /* @__PURE__ */ t("ul", { className: n["header-item-list"], children: o && o.map((e) => e.url || e.categories.length === 0 ? /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t("div", { className: n["link-menu-wrapper"], children: /* @__PURE__ */ t(
      T,
      {
        href: e.url ?? "",
        className: ` ${e.url === E ? `${n["active-link-label"]}` : `${n["link-menu-label"]}`} `,
        children: e.title
      }
    ) }) }, e.title) : /* @__PURE__ */ t("li", { children: /* @__PURE__ */ m(
      "div",
      {
        tabIndex: 0,
        role: "button",
        "aria-label": "toggle menu",
        "data-testid": "megamenu-title-testId",
        "data-pod-name": "commerce",
        className: n["megamenu-title-container"],
        onClick: () => g(e.menuId),
        onKeyDown: () => g(e.menuId),
        children: [
          /* @__PURE__ */ m("span", { className: n["megamenu-title"], children: [
            e.title,
            " "
          ] }),
          /* @__PURE__ */ t(
            x,
            {
              className: n["megamenu-icon"],
              iconName: r === e.menuId ? "chevron-up" : "chevron-down",
              "data-testid": "navbar-icon-test-id",
              "data-pod-name": "commerce"
            }
          )
        ]
      }
    ) }, e.menuId)) }) }),
    /* @__PURE__ */ t(
      "div",
      {
        id: "amway-header-modal",
        "data-testid": "megamenu-modal-id",
        "data-pod-name": "commerce",
        className: `${n["amway-header-megamenu-modal"]} ${r !== "" ? `${n.activeMenu} ${n["slide-down"]} amwayMegaMenuModal` : ""} `,
        ref: h,
        children: /* @__PURE__ */ t(u, { children: /* @__PURE__ */ t("div", { id: "content-full-id", className: n["ahm-content-full"], ref: c, children: /* @__PURE__ */ t("div", { className: n["ahm-on-scroll"], children: /* @__PURE__ */ t("div", { id: "test_it", ref: p, className: `${n["ahm-list"]} full-content`, children: o == null ? void 0 : o.map((e) => r === e.menuId && b(e)) }) }) }) })
      }
    )
  ] });
};
export {
  P as default
};
//# sourceMappingURL=NavigationBar.js.map
